// 0026: generic breadcrumb. Receives an ORDERED trail of crumbs; it does not assume a
// depth, so a future deep tree (root > a > b > c ...) renders with no change. The last
// crumb is the current location (plain text); earlier crumbs are links back up.
import { Link } from "react-router-dom";
import "../../../styles/components/categories/gallery/categoryGalleryBreadcrumb.scss";

// trail: [{ label, to }] — `to` omitted/null on the current (last) crumb.
export const CategoryGalleryBreadcrumb = ({ trail }) => {
  if (!trail || trail.length === 0) return null;

  return (
    <nav className="categoryGalleryBreadcrumb" aria-label="ניווט קטגוריות">
      {trail.map((crumb, index) => {
        const isLast = index === trail.length - 1;
        return (
          <span className="crumb" key={`${crumb.label}-${index}`}>
            {isLast || !crumb.to ? (
              <span className="crumbCurrent" aria-current="page">
                {crumb.label}
              </span>
            ) : (
              <Link className="crumbLink" to={crumb.to}>
                {crumb.label}
              </Link>
            )}
            {!isLast && <span className="crumbSeparator" aria-hidden="true">›</span>}
          </span>
        );
      })}
    </nav>
  );
};

export default CategoryGalleryBreadcrumb;
